import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';
import ExcludedFromBalanceBadge from './badge/ExcludedFromBalanceBadge';

const LeaveEntityHeader = () => {
  return (
    <EntityHeader
      entityTitleSource="id"
      badges={data =>
        data.getValueBySource('balanceInfo.isExcludedFromBalance') ? <ExcludedFromBalanceBadge /> : null
      }
      defaultAuthor={DEFAULT_ENTITY_AUTHOR}
    />
  );
};

export default LeaveEntityHeader;
